import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';

import { AuthProvider } from './components/AuthProvider';
import CookieBanner from './components/CookieBanner';
import FlagsmithProvider from './components/FlagsmithProvider';
import PlausibleAnalytics from './components/PlausibleAnalytics';
import { ThemeProvider } from './components/theme-provider';
import { Toaster } from './components/ui/sonner';

Sentry.init({
  dsn: 'https://74c2edc4e33439cfed3c5c3aa86f5e5d@o4509118821040128.ingest.de.sentry.io/4509260719063120',
  replaysOnErrorSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 1.0, // Capture 100% of transactions in all environments
  beforeSend(event) {
    // This function runs before sending the event to Sentry
    // It's useful for filtering, modifying, or enriching the event data
    return event;
  },
});


const queryClient = new QueryClient();

export default function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <PlausibleAnalytics>
        <QueryClientProvider client={queryClient}>
          <FlagsmithProvider>
            <AuthProvider queryClient={queryClient}>
              <RouterProvider router={router} />
              <Toaster richColors />
              <CookieBanner />
            </AuthProvider>
          </FlagsmithProvider>
        </QueryClientProvider>
      </PlausibleAnalytics>
    </ThemeProvider>
  );
}
